<div>
  <!-- Projects Table -->
  <p-table #table [scrollable]="true" scrollHeight="flex" [value]="projects()" [loading]="loading()" [paginator]="true"
    [rows]="queryParams().limit" [totalRecords]="totalRecords()" [first]="first" [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions" currentPageReportTemplate="{first}-{last} of {totalRecords}"
    [stripedRows]="true" (onPage)="onPageChange($event)">
    <!-- Table Caption with Search and Add Button -->
    <ng-template pTemplate="caption">
      <div class="flex flex-col md:flex-row gap-3 md:gap-2">
        <div class="flex gap-2">
          <p-button label="{{ 'projects.addProject' | translate }}" icon="pi pi-plus" severity="success"
            [disabled]="loading()" [loading]="loading()" (onClick)="addProject()">
          </p-button>
        </div>
        <p-iconfield iconPosition="left" class="md:ml-auto w-full md:w-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input #searchInput pInputText type="text" [formControl]="searchControl"
            [placeholder]="'projects.searchPlaceholder' | translate" class="w-full" />
        </p-iconfield>
      </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name" style="min-width: 250px">
          {{ 'projects.headers.name' | translate }}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="ownerName" style="min-width: 180px">
          {{ 'projects.headers.ownerName' | translate }}
          <p-sortIcon field="ownerName"></p-sortIcon>
        </th>
        <th pSortableColumn="status" style="min-width: 150px">
          {{ 'projects.headers.status' | translate }}
          <p-sortIcon field="status"></p-sortIcon>
        </th>
        <th pSortableColumn="publishedAt" style="min-width: 130px">
          {{ 'projects.headers.publishedAt' | translate }}
          <p-sortIcon field="publishedAt"></p-sortIcon>
        </th>
        <th pSortableColumn="currentRaised" style="min-width: 150px">
          {{ 'projects.headers.currentRaised' | translate }}
          <p-sortIcon field="currentRaised"></p-sortIcon>
        </th>
        <th pSortableColumn="participantsCount" style="min-width: 120px">
          {{ 'projects.headers.participantsCount' | translate }}
          <p-sortIcon field="participantsCount"></p-sortIcon>
        </th>
        <th style="min-width: 220px">{{ 'projects.headers.actions' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-project>
      <tr>
        <td style="min-width: 250px">{{ project.name }}</td>
        <td style="min-width: 180px">{{ project.ownerName }}</td>
        <td style="min-width: 150px">
          <p-tag [value]="getStatusTranslationKey(project) | translate" [severity]="getStatusSeverity(project)" />
        </td>
        <td style="min-width: 130px">{{ project.publishedAt | date:'dd/MM/yyyy' }}</td>
        <td style="min-width: 150px">{{ project.currentRaised | currency }}</td>
        <td style="min-width: 120px">{{ project.participantsCount | number }}</td>
        <td style="min-width: 220px">
          <div class="flex gap-2">
            <!-- Approve button - only for pending_approval -->
            @if (project.status === 'pending_approval') {
            <p-button icon="pi pi-check" [rounded]="true" size="small" severity="success" [disabled]="loading()"
              [ariaLabel]="'projects.approve' | translate" (onClick)="approveProject(project)">
            </p-button>
            }
            <!-- Reject button - only for pending_approval -->
            @if (project.status === 'pending_approval') {
            <p-button icon="pi pi-times" [rounded]="true" size="small" severity="danger" [disabled]="loading()"
              [ariaLabel]="'projects.reject' | translate" (onClick)="rejectProject(project)">
            </p-button>
            }
            <!-- Edit button - always visible -->
            <p-button icon="pi pi-pencil" [rounded]="true" size="small" [disabled]="loading()"
              [ariaLabel]="'projects.edit' | translate" (onClick)="editProject(project)">
            </p-button>
            <!-- Delete button - always visible -->
            <p-button icon="pi pi-trash" [rounded]="true" size="small" [disabled]="loading()"
              [ariaLabel]="'projects.delete' | translate" (onClick)="deleteProject(project)">
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Empty state -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center py-8">
          <div class="flex flex-col items-center gap-3">
            <i class="pi pi-briefcase text-4xl text-muted"></i>
            <p class="text-body-md text-muted">{{ 'projects.noData' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>
</div>
